import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/sprite.svg'
import _imports_1 from '@/assets/image/empty.webp'
import _imports_2 from '@/assets/image/empty.jpg'


const _hoisted_1 = _imports_0 + '#close'
const _hoisted_2 = _imports_1
const _hoisted_3 = { class: "cart-item" }
const _hoisted_4 = { class: "cart-item__left" }
const _hoisted_5 = {
  key: 0,
  class: "cart-item__img"
}
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "cart-item__img"
}
const _hoisted_9 = { class: "cart-item__right" }
const _hoisted_10 = { class: "cart-item__title" }
const _hoisted_11 = { class: "cart-item__case" }
const _hoisted_12 = { class: "cart-item__prices" }
const _hoisted_13 = { class: "cart-item__price-new" }
const _hoisted_14 = { class: "animation-btn" }

import { priceFormat } from "@/helpers/priceFormat";
  import ChangeBasket from "./ChangeBasket.vue";
  import { onMounted, PropType, ref } from "vue";
  import { eventBus } from "@/helpers/eventBus";
  import { IProduct } from "@/models/models";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CartItem',
  props: {
    data: {
      type: Object as PropType<IProduct> | null,
      required: true,
    },
  },
  emits: ["onClear"],
  setup(__props, { emit: __emit }) {

  const props = __props;

  const emit = __emit;

  const basket = ref<Array<IProduct>>([] as Array<IProduct>);

  onMounted(() => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");
  });

  const onDelete = () => {
    basket.value = JSON.parse(localStorage.getItem("basket") || "[]");

    basket.value = basket.value.filter((basketItem: IProduct) => {
      if (basketItem.id == props.data.id) {
        eventBus.emit("delete-card", props.data);
      }

      return basketItem.id != props.data.id;
    });

    if (basket.value.length == 0) {
      emit("onClear");
    }

    localStorage.setItem("basket", JSON.stringify(basket.value));

    eventBus.emit("cart-updated", {});
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_3, [
    _createElementVNode("button", {
      class: "cart-item__close",
      onClick: onDelete
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("svg", {
        width: "20px",
        height: "20px"
      }, [
        _createElementVNode("use", { "xlink:href": _hoisted_1 })
      ], -1)
    ])),
    _createElementVNode("div", _hoisted_4, [
      (__props.data.images.length != 0)
        ? (_openBlock(), _createElementBlock("picture", _hoisted_5, [
            _createElementVNode("source", {
              srcset: 'https://akshop.a-dev.xyz' + __props.data.images[0]
            }, null, 8, _hoisted_6),
            _createElementVNode("img", {
              src: 'https://akshop.a-dev.xyz' + __props.data.images[0],
              alt: __props.data.name,
              loading: "eager"
            }, null, 8, _hoisted_7)
          ]))
        : (_openBlock(), _createElementBlock("picture", _hoisted_8, _cache[1] || (_cache[1] = [
            _createElementVNode("source", { srcset: _hoisted_2 }, null, -1),
            _createElementVNode("img", {
              src: _imports_2,
              alt: "Нет фото",
              loading: "eager"
            }, null, -1)
          ])))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(__props.data.name), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(priceFormat)(__props.data.basePrice)), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(ChangeBasket, { source: __props.data }, null, 8, ["source"])
        ])
      ])
    ])
  ]))
}
}

})